import React from "react";
import { useNavigate } from 'react-router-dom';

const MainPage = () => {

    const navigate = useNavigate();

    return (
        <div style={styles.container}>
            {/* Header Section */}
            <header style={styles.header}>
                <div style={styles.logoContainer}>
                    <h1 style={styles.logo}>VersyTech</h1>
                    <p style={styles.tagline}>Innovating Insurance Operations</p>
                </div>
            </header>

            {/* Main Content Section */}
            <main style={styles.mainContent}>
                <section id="mission" style={styles.section}>
                    <h2 style={styles.sectionTitle}>Our Mission</h2>
                    <p style={styles.sectionText}>
                        At VersyTech, we revolutionize how insurance agents manage their back office.
                        By automating time-consuming tasks, we enable agents to focus on what matters
                        most: serving their clients. Our flagship product, <b>AgentAssistPro</b>, simplifies
                        appointment scheduling, email management, and document handling.
                    </p>
                </section>

                <section id="about" style={styles.section}>
                    <h2 style={styles.sectionTitle}>About AgentAssistPro</h2>
                    <p style={styles.sectionText}>
                        AgentAssistPro streamlines the 9-week Medicare open enrollment period, automating
                        processes like email campaigns, appointment management, and secure document handling.
                        It's already saved agents thousands of hours and transformed their operations.
                    </p>
                </section>

                <section id="join" style={styles.section}>
                    <h2 style={styles.sectionTitle}>Join Us</h2>
                    <p style={styles.sectionText}>
                        Take the first step towards a more efficient future. Discover how AgentAssistPro
                        can transform your operations and give you a competitive edge.
                    </p>
                    {/* New button here */}
                    <button
                        style={styles.ctaButton}
                        //onClick={() => window.location.href = "/agentAssistPro"}
                        onClick={() => navigate("/agentAssistPro")} // Use navigate instead of window.location
                    >
                        Go to Another Page
                    </button>
                </section>
            </main>

            {/* Footer Section */}
            <footer style={styles.footer}>
                <section id="contact" style={styles.footerContent}>
                    <h3 style={styles.footerTitle}>Contact Us</h3>
                    <p style={styles.footerText}>
                        Email: <a href="mailto:info@versytech.com" style={styles.footerLink}>info@versytech.com</a>
                    </p>
                </section>
                <p style={styles.copyText}>&copy; 2025 VersyTech. All rights reserved.</p>
            </footer>
        </div>
    );
};

const styles = {
    container: {
        fontFamily: "Arial, sans-serif",
        color: "#333",
        lineHeight: "1.6",
        textAlign: "center",
    },
    header: {
        backgroundColor: "#0078D4",
        color: "#fff",
        padding: "20px 10px",
        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    },
    logoContainer: {
        marginBottom: "10px",
    },
    logo: {
        fontSize: "2em",
        fontWeight: "bold",
        margin: 0,
    },
    tagline: {
        fontSize: "1em",
        margin: 0,
    },
    mainContent: {
        padding: "20px",
        maxWidth: "800px",
        margin: "0 auto",
    },
    section: {
        marginBottom: "40px",
    },
    sectionTitle: {
        fontSize: "1.8em",
        fontWeight: "bold",
        marginBottom: "10px",
        color: "#0078D4",
    },
    sectionText: {
        fontSize: "1em",
        color: "#555",
    },
    ctaButton: {
        backgroundColor: "#0078D4",
        color: "#fff",
        border: "none",
        padding: "10px 20px",
        fontSize: "1em",
        borderRadius: "5px",
        cursor: "pointer",
        transition: "background-color 0.3s ease",
    },
    ctaButtonHover: {
        backgroundColor: "#005a9e",
    },
    footer: {
        backgroundColor: "#f8f8f8",
        color: "#555",
        padding: "20px",
        borderTop: "1px solid #eaeaea",
    },
    footerContent: {
        marginBottom: "20px",
    },
    footerTitle: {
        fontSize: "1.2em",
        marginBottom: "10px",
    },
    footerText: {
        fontSize: "1em",
        margin: "5px 0",
    },
    footerLink: {
        textDecoration: "none",
        color: "#0078D4",
    },
    copyText: {
        fontSize: "0.9em",
        color: "#777",
    },
};

export default MainPage;
